import React, { useState } from "react";

import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";

const ReactComponentProps = ({ propsList, onAdd }) => {
  const [showAddProp, setShowAddProp] = useState(false);
  const [propName, setPropName] = useState("");

  const onEnterHandler = (e) => {
    if (e.key === "Enter") {
      onAdd([...propsList, { name: propName, dataKey: "" }]);
      setShowAddProp(false);
      setPropName("");
    }
  };

  const onDeleteHandler = (propName) => {
    const newPropsList = propsList.filter((prop) => prop.name !== propName);

    onAdd(newPropsList);
  };

  return (
    <div className="flex_column space_y_2">
      <h3>Props</h3>
      <div className="flex_wrap align_center mb_2">
        <div className="d_flex">
          {propsList.map((prop) => (
            <div className="position_relative props_parent" key={prop.name}>
              <span style={{ marginLeft: "5px" }} className="border_full p_2 ">
                {prop.name}
              </span>

              <button
                style={{ top: "-20px", right: "0px" }}
                className="position_absolute builder_action_btn  delete prop_delete"
              >
                <span
                  onClick={() => onDeleteHandler(prop.name)}
                  style={{ fontSize: "16px" }}
                  className="material-symbols-outlined"
                >
                  delete
                </span>
              </button>
            </div>
          ))}
        </div>

        {showAddProp ? (
          <input
            onChange={(e) => setPropName(e.target.value)}
            onKeyDown={onEnterHandler}
            autoFocus={true}
            className="builder_input w_fit ml_2"
            placeholder="Enter prop name"
          />
        ) : (
          // <Button onClick={() => setShowAddProp(true)} size="small" className="ml_2" type="small" title="Add Prop "  style={{height:"35px"}}>
          //   <span className="material-symbols-outlined font_size_small">add</span>
          // </Button>
          <ButtonActionIcon type="add" onClick={() => setShowAddProp(true)} />
        )}
      </div>
    </div>
  );
};

export default ReactComponentProps;
